<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('siteProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('siteProfile.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-between">
          <div>
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table-filter
        :columns="columns"
        :data="resources"
        :loading="loading"
        @search="search"
      >
        <template slot-scope="{ row }" slot="action">
          <div class="ts-flex ts-space-x-2" style="width: fit-content;">
            <a
              href="#"
              class="ts-text-yellow-500"
              v-if="row.check_in_outs.length"
              @click.prevent="onViewMap(row)"
            >
              <Icon type="ios-map" size="20" />
            </a>
            <a
              href="#"
              class="text-primary"
              @click.prevent="onEdit(row)"
              v-tooltip="$t('edit')"
            >
              <Icon type="ios-create" size="20" />
            </a>
            <a
              href="#"
              class="text-danger"
              v-tooltip="$t('delete')"
              @click="deleteRecord(row)"
              :disabled="row._deleting"
            >
              <i class="fas fa-circle-notch fa-spin" v-if="row._deleting"></i>
              <Icon type="ios-trash" size="20" v-else />
            </a>
          </div>
        </template>
      </ts-table-filter>
      <div class="ts-flex ts-items-center ts-justify-end ts-p-4">
        <ts-i-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-i-pagination>
      </div>
    </ts-card>
    <iModalWrapper v-model="show_modal" title="Create Site">
      <Form v-if="show_modal" @cancel="onCancelModal" />
    </iModalWrapper>
    <iModalWrapper v-model="show_modal_update" title="Update Site">
      <FormUpdate
        v-if="show_modal_update"
        @cancel="onCancelModal"
        :edit_data="edit_data"
      />
    </iModalWrapper>
    <a-modal
      v-if="show_checkinout"
      v-model="show_checkinout"
      title="View Check In/Out"
      width="80%"
      :zIndex="1020"
      :footer="null"
    >
      <ViewMap :siteView="siteView" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import iModalWrapper from '../components/i-modal-wrapper.vue'
import Form from './form.vue'
import FormUpdate from './form-update.vue'
import ViewMap from './view-map.vue'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    iModalWrapper,
    Form,
    FormUpdate,
    ViewMap
  },
  data() {
    return {
      loading: false,
      show_modal: false,
      show_modal_update: false,
      edit_data: undefined,
      show_checkinout: false,
      siteView: {}
    }
  },
  computed: {
    ...mapState('projectMgt/siteProfile', ['resources', 'pagination']),
    columns() {
      return [
        {
          title: this.$t('siteProfile.siteName'),
          key: 'site_name',
          keySearch: 'site_name',
          search: true
        },
        {
          title: this.$t('siteProfile.siteOwner'),
          key: 'owner_name_en',
          keySearch: 'emp.employee_name_en'
        },
        {
          title: this.$t('siteProfile.location'),
          key: 'geolocation'
        },
        {
          title: this.$t('siteProfile.createdBy'),
          key: 'created_by_name',
          keySearch: 'empc.employee_name_en',
          search: true
        },
        {
          title: this.$t('siteProfile.remark'),
          key: 'remarks',
          keySearch: 'remarks',
          search: true
        },
        {
          title: this.$t('actions'),
          slot: 'action',
          searchIcon: true,
          width: 150
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('projectMgt/siteProfile', ['fetch', 'destroy']),
    search(newValue) {
      this.$store.commit('projectMgt/siteProfile/SET_SEARCH', newValue)
      this.$store.commit('projectMgt/siteProfile/RESET_CURRENT_PAGE')
      this.fetchData()
    },
    addNew() {
      this.show_modal = true
    },
    fetchData(attributes) {
      this.loading = true
      this.fetch(attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    onCancelModal() {
      this.show_modal = false
      this.show_modal_update = false
      this.edit_data = undefined
      this.fetchData()
    },
    onEdit(record) {
      this.show_modal_update = true
      this.edit_data = record
    },
    deleteRecord(record) {
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        centered: true,
        onOk: () => {
          return this.destroy(record.id)
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    },
    onViewMap(record) {
      this.siteView = record
      this.show_checkinout = true
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500)
  }
}
</script>
